import React, { useState, useEffect, useMemo, useCallback } from 'react'
import Card from 'react-bootstrap/Card';
import ReactDataTableBootstrap from '../../Components/ReactDataTableBootstrap/ReactDataTableBootstrap';
import Controllers from '../../Api/Controllers';
import Helpers from '../../Components/Helpers/Helpers';
import { toast } from 'react-toastify'
import { CheckBox, FormCustom, Input, Select } from '../../Components/Form/Form';
import ReactPlaceholder from 'react-placeholder'
import Button from 'react-bootstrap/esm/Button';
import { useSelector } from 'react-redux';
import SweetAlert from '../../Components/SweetAlert/SweetAlert';
import Modal from 'react-bootstrap/esm/Modal';
import Loading from '../../Components/Layout/Styled/Loading';

const PointPeriod = _ => {
    const [ready, setReady] = useState(false)
    const [isProcessing, setIsProccesing] = useState(false)
    const [periodSelected, setPeriodSelected] = useState('')
    const [rows, setRows] = useState({
        money: [],
        details: []
    })
    const [period, setPeriod] = useState([])
    const [reporte, setReport] = useState({})
    const [reporteFolio, setReporteFolio] = useState({})

    const permissions = useSelector(store => store.session.permissions)
    const actionsModule = Helpers.getActions({ permissions, module: 'comisiones-periodo' })

    const [limits, setLimits] = useState([])
    const [showAlert, setShowAlert] = useState(false);
    const [timbrarModal, setTimbrarModal] = useState({
        p_name: '',
        p_id_customers: '',
        p_id_period: '',
        p_rfc_customers: '',
        p_zip_code_customers: '',
        p_id_regimen_nomina: '',
        p_id_cfdi_nomina: '',
        p_curp_customers: '',
        loadSubmit: false,
        p_facturama_error: '',
        p_subtotal: 0,
    })
    const [isr, setIsr] = useState(0)
    const [total, setTotal] = useState(0)

    const [csvMasivo, setCsvMasivo] = useState({
        p_csv: '',
        p_id_period: '',
        p_rows: {},
        p_show_details: false,
        p_process: false,
        p_generate_invoices: false,
        p_show_button_generate: true,
        p_rows_invoices: {}
    })

    const [regimen, setRegimen] = useState([]);
    const [cfdi, setCfdi] = useState([]);
    const [totalRequest, setTotalRequest] = useState(0);

    const [modalDescuentos, setModalDescuentos] = useState(false);
    const [csvDesc, setCsvDesc] = useState({
        p_csv: '',
        p_id_period: '',
        p_process: false,
        p_errors: [],
    })

    useEffect(() => {
        Controllers.regimen.get_regimen().then(res => {
            setRegimen(res.data)
        })
        Controllers.cfdi.get_cfdi().then(res => {
            setCfdi(res.data)
        })

        Controllers.period.get_period().then(res => {
            setPeriod(res.data)
            setReady(true)
        })
        Controllers.limit.get_limit().then(res => {
            setLimits(res.data)
        })
    }, [])

    const handleSubmit = _ => {
        if (!periodSelected) {
            Helpers.toast.construct({
                response: 'warning',
                message: 'Selecciona un periodo',
                toast
            })
            return
        }

        setIsProccesing(true)
        setReport({})
        setReporteFolio({})
        Controllers.report.get_report_commissions_period({
            p_id_period: periodSelected
        }).then(res => {
            setRows(res.data)
            setReport({
                excel: res.data.excel.file,
                filename: res.data.excel.filename,
            })
            setReporteFolio({
                excel: res.data.excel_folio.file,
                filename: res.data.excel_folio.filename,
            })
        }).catch(req => Helpers.promise.catch({ req, toast }))
            .finally(() => {
                setIsProccesing(false)
            })
    }

    const moneyList = useCallback(() => {
        let m = []
        for (const key in rows.money) {
            m.push(<h4><strong>{key}</strong> {rows.money[key]}</h4>)
        }
        return m
    }, [rows])

    const confirmTimbrar = () => {
        setTimbrarModal({
            ...timbrarModal,
            loadSubmit: true,
        })
        Controllers.facturama.send_commission_to_facturama({
            p_id_customers: timbrarModal.p_id_customers,
            p_id_period: timbrarModal.p_id_period,
            p_rfc_customers: timbrarModal.p_rfc_customers,
            p_zip_code_customers: timbrarModal.p_zip_code_customers,
            p_id_regimen_nomina: timbrarModal.p_id_regimen_nomina,
            p_id_cfdi_nomina: timbrarModal.p_id_cfdi_nomina,
            p_curp_customers: timbrarModal.p_curp_customers,
            p_change_total: timbrarModal.p_change_total ? 1 : 0,
            p_subtotal: timbrarModal.p_subtotal,
            p_total: total.toFixed(2),
            p_isr: isr.toFixed(2),
        }).then(res => {
            Helpers.toast.construct({
                ...res,
                toast,
            })

            if (res.response === 'success') {
                setTimbrarModal({
                    ...timbrarModal,
                    loadSubmit: false,
                })
                setShowAlert(false)
                handleSubmit();
            } else {
                setTimbrarModal({
                    ...timbrarModal,
                    loadSubmit: false,
                })
                handleSubmit();
            }
        }).catch(req => {
            Helpers.promise.catch({ req, toast })
            setTimbrarModal({
                ...timbrarModal,
                loadSubmit: false,
            })
            handleSubmit();
        })
    }

    useEffect(() => {
        let isr = 0;
        let total = 0;
        const subtotal = isNaN(parseFloat(timbrarModal.p_subtotal)) ? 0 : parseFloat(timbrarModal.p_subtotal)
        const findLimit = limits.find(l => subtotal >= l.min_limit && subtotal <= l.max_limit)

        if (findLimit) {
            isr = parseFloat((subtotal - parseFloat(findLimit.min_limit)) * parseFloat(findLimit.percentage_limit) + parseFloat(findLimit.quota_limit))
            total = subtotal - isr
        } else {
            total = timbrarModal.p_subtotal
        }

        setIsr(isr)
        setTotal(total)
    }, [timbrarModal.p_subtotal, limits])

    const dtRows = useMemo(() => <ReactDataTableBootstrap
        head={[
            [
                { name: 'key_branch_office', text: 'Sucursal', align: 'center' },
                { name: 'id_customers', text: 'ID', align: 'center' },
                { name: 'full_name', text: 'Nombres' },
                { name: 'point_current_customers_parent', text: 'Puntos' },
                { name: 'point_business_customers_parent', text: 'Puntos Negocio' },
                { name: 'name_plan', text: 'Rango' },
                { name: 'type_fee', text: 'Régimen', align: 'center' },
                { name: 'subtotal_earnings', text: 'Ganancia', align: 'center', render: r => '$ ' + r.subtotal_earnings },
                { name: 'isr', text: 'ISR', align: 'center', render: r => r.isr ? '$ ' + r.isr : '' },
                { name: 'iva', text: 'IVA', align: 'center', render: r => r.iva ? '$ ' + r.iva : '' },
                { name: 'ret_iva', text: 'RET IVA', align: 'center', render: r => r.ret_iva ? '$ ' + r.ret_iva : '' },
                { name: 'resico', text: 'RESICO', align: 'center', render: r => r.resico ? '$ ' + r.resico : '' },
                { name: 'total', text: 'Total', align: 'center', render: r => '$ ' + r.total },
                {
                    name: 'total_changed', text: 'Total Pagado', align: 'center', render: r => {
                        if (r.facturama_id) {
                            return r.total_changed ? '$ ' + r.total_changed : ''
                        }
                    }
                },
                { name: 'code_money', text: 'Moneda', align: 'center' },
                {
                    name: 'actions', text: 'Factura', align: 'center', render: u => {
                        if (!actionsModule?.invoice) {
                            return '';
                        }

                        if (u.code_money !== 'MXN') {
                            return '';
                        }

                        if (u.facturama_id) {
                            return <div className='d-flex'>
                                <div className="align-self-center">
                                    <strong className='mr-2 text-success'>FACTURADO</strong>
                                </div>
                                <a href={Helpers.config.apiUrl({
                                    url: '/facturama/nomina/pdf/' + u.facturama_id
                                })} target='_blank' rel='noreferrer'>
                                    <Button variant="danger" size='xs' className='align-self-center'>
                                        <i className='fa fa-file-pdf'></i>
                                    </Button>
                                </a>
                            </div>
                        }

                        if (u.type_fee === 'ASIMILADOS') {
                            return <div>
                                <Button className="mr-1" size="xs" data-id-period={u.id_period} data-full-name={u.full_name} data-id-customers={u.id_customers} variant={actionsModule.invoice.color} onClick={(e) => {

                                    let $this = e.currentTarget

                                    const { fullName, idCustomers, idPeriod } = e.currentTarget.dataset

                                    let buttonHTML = $this.innerHTML;
                                    $this.innerHTML = '<i class="fa fa-circle-notch fa-spin"></i>'

                                    Controllers.customers.get_customers_id({ p_id_customers: u.id_customers }).then(res => {
                                        setTimbrarModal({
                                            p_name: `${idCustomers} - ${fullName}`,
                                            p_id_customers: res.data.id_customers,
                                            p_id_period: idPeriod,
                                            p_rfc_customers: res.data.rfc_nomina,
                                            p_zip_code_customers: res.data.zip_code_nomina,
                                            p_id_regimen_nomina: res.data.id_regimen_nomina,
                                            p_id_cfdi_nomina: res.data.id_cfdi_nomina,
                                            p_curp_customers: res.data.curp_nomina,
                                            loadSubmit: false,
                                            p_facturama_error: u.facturama_error,
                                            p_change_total: parseInt(u.change_total) === 1,
                                            p_subtotal_original: u.subtotal_earnings_original,
                                            p_subtotal: parseInt(u.change_total) === 1 ? u.subtotal_changed : u.subtotal_earnings_original,
                                        })
                                        setShowAlert(true)
                                    }).catch(req => {
                                        Helpers.promise.catch({ req, toast })
                                    })
                                        .finally(() => $this.innerHTML = buttonHTML)

                                }}>
                                    <i className={actionsModule.invoice.icon}></i>
                                </Button>
                            </div>
                        }
                    }
                },
            ],
        ]}
        rows={rows.details}
        pageLength={100}
        isProcessing={isProcessing}
    />, [rows, isProcessing, actionsModule])

    const cboRegimen = useMemo(() => {
        if (!timbrarModal.p_id_regimen_nomina) {
            return ''
        }

        let finded = regimen.find(t => parseInt(timbrarModal.p_id_regimen_nomina) === parseInt(t.id_regimen))

        if (!finded) {
            return ''
        }
        return {
            label: `${finded.id_regimen} - ${finded.name_regimen}`,
            value: finded.id_regimen
        }
    }, [timbrarModal.p_id_regimen_nomina, regimen])

    const cboCfdi = useMemo(() => {
        if (!timbrarModal.p_id_cfdi_nomina) {
            return ''
        }

        let finded = cfdi.find(t => (timbrarModal.p_id_cfdi_nomina) === (t.id_cfdi))

        if (!finded) {
            return ''
        }
        return {
            label: `${finded.id_cfdi} - ${finded.name_cfdi}`,
            value: finded.id_cfdi
        }
    }, [timbrarModal.p_id_cfdi_nomina, cfdi])

    const [modalMasivo, setModalMasivo] = useState(false);

    console.log(csvDesc)

    // if (Helpers.date.get({ format: '%Y-%m-%d' }) >= '2026-02-17') {
    //     return <></>
    // }
    
    return <>
        <ReactPlaceholder rows={10} showLoadingAnimation ready={ready}>
            <Card>
                <Card.Header className="justify-content-between">
                    <div>
                        <span>Comisiones por Periódo</span>
                    </div>
                    <div className='align-self-center'>
                        <Button variant="dark mr-2" onClick={() => {
                            setCsvMasivo({
                                ...csvMasivo,
                                p_rows: [],
                                p_show_details: false,
                                p_process: false,
                                p_show_button_generate: true,
                                p_rows_invoices: {}
                            })
                            setTotalRequest(0)
                            setModalMasivo(true)
                        }} size="sm">
                            <i className="fas fa-file-invoice"></i>
                            <span className='ml-2'>Factura Masiva</span>
                        </Button>
                        <Button variant="info" onClick={() => {
                            setCsvDesc({
                                ...csvDesc,
                                p_process: false,
                                p_errors: [],
                            })
                            setModalDescuentos(true)
                        }} size="sm">
                            <i className="fas fa-file-invoice"></i>
                            <span className='ml-2'>Descuentos</span>
                        </Button>
                    </div>
                </Card.Header>
                <Card.Body>
                    <FormCustom viewSubmit={false}>
                        <Select
                            text="Periódo"
                            classNameParent="col-12 mb-2"
                            options={period.map(p => {
                                return {
                                    label: p.name_period,
                                    value: p.id_period
                                }
                            })}
                            onChange={e => {
                                setPeriodSelected(e.value)
                                setReporteFolio({})
                                setReport({})
                            }}
                            append={[
                                <Button onClick={handleSubmit}>
                                    <i className="fa fa-search"></i>
                                </Button>,
                            ]}
                        />
                    </FormCustom>
                    <div className="d-flex">
                        {reporte?.filename ? <div className='mt-2 mb-2 mr-2'>
                            <a href={reporte?.excel} download={reporte?.filename}>
                                <Button size="sm" variant="success">
                                    <i className="fa fa-file-excel mr-2"></i>Descargar Reporte Excel
                                </Button>
                            </a>
                        </div> : ''}
                        {reporteFolio?.filename ? <div className='mt-2 mb-2'>
                            <a href={reporteFolio?.excel} download={reporteFolio?.filename}>
                                <Button size="sm" variant="dark">
                                    <i className="fa fa-file-excel mr-2"></i>Descargar Reporte Folio
                                </Button>
                            </a>
                        </div> : ''}
                    </div>
                    {dtRows}
                </Card.Body>
            </Card>
            {isProcessing ? '' : <div className="d-flex justify-content-center mt-4">
                <div className="alert alert-success text-center">
                    <h5>Total de Comisiones</h5>
                    {moneyList()}
                </div>
            </div>}

            <SweetAlert
                icon="approve"
                iconClassName="fas fa-file-invoice text-primary"
                show={showAlert}
                showCancelButton
                title={<>¿Desea timbrar la comisión?</>}
                subtitle={<>#{timbrarModal.p_name}</>}
                confirmButtonText="¡Sí, timbrar!"
                cancelButtonText="¡No, cancelar!"
                loadSubmit={timbrarModal.loadSubmit}
                onCancel={() => setShowAlert(false)}
                onConfirm={confirmTimbrar}
                content={_ => {
                    return <>
                        {timbrarModal.p_facturama_error && <div className="col-12 mb-2">
                            <small className='text-danger'>
                                {timbrarModal.p_facturama_error}
                            </small>
                        </div>}
                        <Input
                            text="RFC"
                            placeholder="RFC"
                            classNameParent="col-12 mb-2"
                            icon="far fa-comment-alt"
                            required
                            invalid="El campo es obligatorio."
                            value={timbrarModal.p_rfc_customers}
                            onChange={e => {
                                setTimbrarModal({ ...timbrarModal, p_rfc_customers: e.currentTarget.value })
                            }}
                        />
                        <Input
                            text="CURP"
                            placeholder="CURP"
                            classNameParent="col-12 mb-2"
                            icon="far fa-comment-alt"
                            required
                            invalid="El campo es obligatorio."
                            value={timbrarModal.p_curp_customers}
                            onChange={e => {
                                setTimbrarModal({ ...timbrarModal, p_curp_customers: e.currentTarget.value })
                            }}
                        />
                        <Input
                            text="Código Postal"
                            placeholder="Código Postal"
                            classNameParent="col-12 mb-2"
                            icon="far fa-comment-alt"
                            required
                            invalid="El campo es obligatorio."
                            value={timbrarModal.p_zip_code_customers}
                            onChange={e => {
                                setTimbrarModal({ ...timbrarModal, p_zip_code_customers: e.currentTarget.value })
                            }}
                        />
                        <Select
                            classNameParent="col-12 mb-2"
                            icon="far fa-building"
                            text="Uso de CFDI"
                            options={cfdi.map(t => {
                                return {
                                    label: `${t.id_cfdi} - ${t.name_cfdi}`,
                                    value: t.id_cfdi
                                }
                            })}
                            value={cboCfdi}
                            onChange={e => {
                                setTimbrarModal({ ...timbrarModal, p_id_cfdi_nomina: e.value, p_id_regimen_nomina: '' })
                            }}
                        />
                        <Select
                            classNameParent="col-12 mb-2"
                            icon="far fa-building"
                            text="Régimen Fiscal"
                            options={regimen.filter(r => {
                                if (!timbrarModal.p_id_cfdi_nomina) {
                                    return false
                                }

                                const cfdiAux = cfdi.find(t => t.id_cfdi === timbrarModal.p_id_cfdi_nomina)

                                if (!cfdiAux) {
                                    return false
                                }

                                return cfdiAux.regimen_ids.includes(r.id_regimen)
                            }).map(t => {
                                return {
                                    label: `${t.id_regimen} - ${t.name_regimen}`,
                                    value: t.id_regimen
                                }
                            })}
                            value={cboRegimen}
                            onChange={e => {
                                setTimbrarModal({ ...timbrarModal, p_id_regimen_nomina: e.value })
                            }}
                        />
                        <CheckBox
                            id="change-total"
                            classNameParent="col-12 mt-2 align-self-center"
                            text="¿Cambiar total?"
                            checked={timbrarModal.p_change_total}
                            onChange={e => {
                                setTimbrarModal({
                                    ...timbrarModal,
                                    p_change_total: e.currentTarget.checked,
                                    p_subtotal: e.currentTarget.checked ? timbrarModal.p_subtotal : timbrarModal.p_subtotal_original
                                })
                            }}
                        />
                        <Input
                            text="Subtotal"
                            placeholder="Subtotal"
                            classNameParent="col-12 mb-2"
                            icon="far fa-comment-alt"
                            required
                            invalid="El campo es obligatorio."
                            value={timbrarModal.p_subtotal}
                            onChange={e => {
                                setTimbrarModal({ ...timbrarModal, p_subtotal: e.currentTarget.value })
                            }}
                            disabled={!timbrarModal.p_change_total}
                            type="number"
                            step="0.01"
                            min="0.01"
                        />
                        <Input
                            text="ISR"
                            placeholder="ISR"
                            classNameParent="col-12 mb-2"
                            icon="far fa-comment-alt"
                            required
                            invalid="El campo es obligatorio."
                            value={parseFloat(isr).toFixed(2)}
                            disabled
                        />
                        <Input
                            text="Total a Pagar"
                            placeholder="Total a Pagar"
                            classNameParent="col-12 mb-2"
                            icon="far fa-comment-alt"
                            required
                            invalid="El campo es obligatorio."
                            value={parseFloat(total).toFixed(2)}
                            disabled
                        />
                    </>
                }}
            />
        </ReactPlaceholder>

        <Modal show={modalMasivo} onHide={() => setModalMasivo(false)} backdrop="static" size='xl'>
            <Modal.Header closeButton>
                <Modal.Title as="div">Factura Masiva</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <FormCustom viewSubmit={false} onSubmit={() => {
                    if (!csvMasivo.p_id_period) {
                        Helpers.toast.construct({
                            response: 'warning',
                            message: 'Debe seleccionar un período.',
                            toast
                        })
                        return
                    }

                    setCsvMasivo({
                        ...csvMasivo,
                        p_show_details: false,
                        p_process: true
                    })

                    const fd = new FormData()
                    fd.append('p_csv', csvMasivo.p_csv)
                    fd.append('p_id_period', csvMasivo.p_id_period)

                    Controllers.facturama.validate_csv_commissions(fd).then(res => {
                        setCsvMasivo({
                            ...csvMasivo,
                            p_rows: res.data,
                            p_show_details: true,
                            p_process: false,
                            p_show_button_generate: true,
                            p_rows_invoices: {}
                        })

                        setTotalRequest(res.data.pending)
                    }).catch(() => {
                        setCsvMasivo({
                            ...csvMasivo,
                            p_rows: [],
                            p_show_details: false,
                            p_process: false,
                            p_show_button_generate: true,
                            p_rows_invoices: {}
                        })
                        setTotalRequest(0)
                    })
                }}>
                    <Select
                        text="Periódo"
                        classNameParent="col-12 mb-2"
                        options={period.map(p => {
                            return {
                                label: p.name_period,
                                value: p.id_period
                            }
                        })}
                        onChange={e => {
                            setCsvMasivo({
                                ...csvMasivo,
                                p_id_period: e.value,
                                p_show_details: false,
                                p_rows: [],
                                p_csv: '',
                                p_rows_invoices: {}
                            })
                            document.getElementById('fl-csv').value = ''
                        }}
                    />
                    <Input
                        type="file"
                        id="fl-csv"
                        text="Archivo CSV"
                        classNameParent="col-12 mb-3"
                        required
                        invalid="El campo es obligatorio."
                        accept=".csv"
                        onChange={e => {
                            setCsvMasivo({
                                ...csvMasivo,
                                p_csv: e.currentTarget.files[0],
                                p_show_details: false,
                                p_rows: [],
                                p_rows_invoices: {}
                            })
                        }}
                    />
                    <div className="col-12">
                        <Button type="submit" size="sm" disabled={csvMasivo.p_process}>
                            {!csvMasivo.p_process ? <>
                                <i className="fa fa-search"></i>
                                <span className="ml-2">Procesar</span>
                            </> : <>
                                <i className="fa fa-circle-notch fa-spin"></i>
                            </>}
                        </Button>
                    </div>
                </FormCustom>

                {csvMasivo.p_show_details && <>
                    <hr />
                    <div className="form-row">
                        <div className="col-12"><strong>Detalle</strong></div>
                        <div className="col-12">
                            <div className='font-weight-bold mb-2'>
                                <span className='text-success'>Pendientes:</span> {csvMasivo.p_rows.pending}
                            </div>
                            <div className='font-weight-bold mb-2'>
                                <span className='text-primary'>Facturados:</span> {csvMasivo.p_rows.sent}
                                <small>
                                    <Button size="sm" variant="link" onClick={() => {
                                        const transform = csvMasivo.p_rows.sent_customers.map(r => {
                                            return [r]
                                        })

                                        let csvContent = "data:text/csv;charset=utf-8,"
                                            + [
                                                ['ID'],
                                                ...transform
                                            ].map(e => e.join(",")).join("\n");

                                        const encodedUri = encodeURI(csvContent);
                                        const link = document.createElement("a");
                                        link.setAttribute("href", encodedUri);
                                        link.setAttribute("download", "facturados.csv");
                                        document.body.appendChild(link); // Required for FF

                                        link.click();
                                    }}>
                                        <i className="fa fa-download"></i>
                                    </Button>
                                </small>
                                <small className='text-muted ml-2'>(Ya tienen factura generada)</small>
                            </div>
                            {/* <div className='d-flex flex-column'>
                                {React.Children.toArray(csvMasivo.p_rows.sent_customers.map(r => {
                                    return <div>- {r}</div>
                                }))}
                            </div> */}
                            <div className='font-weight-bold mb-2'>
                                <span className='text-warning'>No Encontrados:</span> {csvMasivo.p_rows.not_exists}
                                <small>
                                    <Button size="sm" variant="link" onClick={() => {
                                        const transform = csvMasivo.p_rows.not_exists_customers.map(r => {
                                            return [r]
                                        })

                                        let csvContent = "data:text/csv;charset=utf-8,"
                                            + [
                                                ['ID'],
                                                ...transform
                                            ].map(e => e.join(",")).join("\n");

                                        const encodedUri = encodeURI(csvContent);
                                        const link = document.createElement("a");
                                        link.setAttribute("href", encodedUri);
                                        link.setAttribute("download", "no_encontrados.csv");
                                        document.body.appendChild(link); // Required for FF

                                        link.click();
                                    }}>
                                        <i className="fa fa-download"></i>
                                    </Button>
                                </small>
                                <small className='text-muted ml-2'>(No generan comisión o no son asimiliados)</small>
                            </div>
                            {/* <div className='d-flex flex-column'>
                                {React.Children.toArray(csvMasivo.p_rows.not_exists_customers.map(r => {
                                    return <div>- {r}</div>
                                }))}
                            </div> */}
                        </div>
                        <div className='col-12'>
                            <div class="progress">
                                <div role="progressbar" class="progress-bar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" id="progress-bar"></div>
                            </div>
                            <div>
                                <span id="qty_processed">0</span> / {totalRequest}
                            </div>
                        </div>
                        {csvMasivo.p_show_button_generate && <div className="col-12 mt-2">
                            <Button type="submit" size="sm" variant="success" disabled={csvMasivo.p_rows.pending === 0} onClick={async () => {
                                setCsvMasivo({
                                    ...csvMasivo,
                                    p_generate_invoices: true
                                })

                                const pending = csvMasivo.p_rows.pending
                                const data = [];
                                const split = parseInt(pending / 4)
                                const rest = pending - (split * 4)

                                for (let i = 0; i < split; i++) {
                                    data.push(
                                        csvMasivo.p_rows.pending_customers.slice(i * 4, (i + 1) * 4)
                                    )
                                }

                                if (rest > 0) {
                                    data.push(
                                        csvMasivo.p_rows.pending_customers.slice(split * 4, split * 4 + rest)
                                    )
                                }

                                const responseFinal = {
                                    sent: 0,
                                    not_sent: 0,
                                    not_sent_customers: [],
                                }

                                await data.reduce(async (previousPromise, line) => {
                                    await previousPromise

                                    await Promise.all(line.map(r => {
                                        return Controllers.facturama.send_commission_to_facturama_direct({
                                            p_id_customers: r,
                                            p_id_period: csvMasivo.p_id_period
                                        })
                                    })).then(res => {
                                        document.getElementById('qty_processed').innerHTML = parseInt(document.getElementById('qty_processed').innerHTML) + line.length

                                        document.getElementById('progress-bar').style.width = parseInt(document.getElementById('qty_processed').innerHTML) * 100 / totalRequest + '%'

                                        res.forEach(rr => {
                                            if (rr.response === 'success') {
                                                responseFinal.sent = responseFinal.sent + 1
                                            } else {
                                                responseFinal.not_sent = responseFinal.not_sent + 1
                                                responseFinal.not_sent_customers.push({
                                                    id: rr.data.id_customers,
                                                    message: rr.message.toString().trim()
                                                })
                                            }
                                        })
                                    })

                                    await new Promise(resolve => setTimeout(resolve, 1000))

                                    return Promise.resolve()
                                }, Promise.resolve())

                                setTimeout(() => {
                                    setCsvMasivo({
                                        ...csvMasivo,
                                        p_show_button_generate: false,
                                        p_generate_invoices: false,
                                        p_rows_invoices: responseFinal
                                    })
                                }, 1000)
                            }}>
                                <i className="fa fa-check"></i>
                                <span className="ml-2">Generar Factura Masiva</span>
                            </Button>
                        </div>}
                        {csvMasivo.p_rows_invoices.hasOwnProperty('sent') && <>
                            <div className="col-12 mt-2">
                                <hr />
                            </div>
                            <div className="col-12"><strong>Resumen de Facturas</strong></div>
                            <div className="col-12">
                                <div className='font-weight-bold mb-2'>
                                    <span className='text-success'>Facturados:</span> {csvMasivo.p_rows_invoices.sent}
                                </div>
                                <div className='font-weight-bold mb-2'>
                                    <span className='text-danger'>No Facturados:</span> {csvMasivo.p_rows_invoices.not_sent}
                                    <small>
                                        <Button size="sm" variant="link" onClick={() => {
                                            const transform = csvMasivo.p_rows_invoices.not_sent_customers.map(r => {
                                                return [r.id, r.message]
                                            })

                                            let csvContent = "data:text/csv;charset=utf-8,"
                                                + [
                                                    ['ID', 'Error'],
                                                    ...transform
                                                ].map(e => e.join(",")).join("\n");

                                            const encodedUri = encodeURI(csvContent);
                                            const link = document.createElement("a");
                                            link.setAttribute("href", encodedUri);
                                            link.setAttribute("download", "no_facturados.csv");
                                            document.body.appendChild(link); // Required for FF

                                            link.click();
                                        }}>
                                            <i className="fa fa-download"></i>
                                        </Button>
                                    </small>
                                    <small className='text-muted ml-2'>(Revisar RFC, CURP y demás)</small>
                                </div>
                                {/* <div className='d-flex flex-column'>
                                    {React.Children.toArray(csvMasivo.p_rows_invoices.not_sent_customers.map(r => {
                                        return <div>- {r}</div>
                                    }))}
                                </div> */}
                            </div>
                        </>}
                    </div>
                </>}
            </Modal.Body>
        </Modal>

        <Modal show={modalDescuentos} onHide={() => setModalDescuentos(false)} backdrop="static" size='xl'>
            <Modal.Header closeButton>
                <Modal.Title as="div">Descuentos</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <FormCustom viewSubmit={false} onSubmit={() => {
                    if (!csvDesc.p_id_period) {
                        Helpers.toast.construct({
                            response: 'warning',
                            message: 'Debe seleccionar un período.',
                            toast
                        })
                        return
                    }

                    /* setCsvDesc({
                        ...csvDesc,
                        p_process: true
                    }) */

                    const fd = new FormData()
                    fd.append('p_csv', csvDesc.p_csv)
                    fd.append('p_id_period', csvDesc.p_id_period)

                    Controllers.report.readCsvWithCommissionsDiscount(fd).then(res => {
                        console.log(res.data.errors)
                        if (res.response !== 'success') {
                            setCsvDesc({
                                ...csvDesc,
                                p_process: false,
                                p_errors: res.data.errors
                            })
                        } else {
                            setCsvDesc({
                                ...csvDesc,
                                p_process: false,
                                p_errors: []
                            })
                        }
                    }).catch(() => {
                        setCsvDesc({
                            ...csvDesc,
                            p_process: false,
                            p_errors: []
                        })
                    })
                }}>
                    <Select
                        text="Periódo"
                        classNameParent="col-12 mb-2"
                        options={period.map(p => {
                            return {
                                label: p.name_period,
                                value: p.id_period
                            }
                        })}
                        onChange={e => {
                            setCsvDesc({
                                ...csvDesc,
                                p_id_period: e.value,
                                p_csv: '',
                                p_errors: []
                            })
                            document.getElementById('fl-csv').value = ''
                        }}
                    />
                    <Input
                        type="file"
                        id="fl-csv"
                        text="Archivo CSV"
                        classNameParent="col-12 mb-3"
                        required
                        invalid="El campo es obligatorio."
                        accept=".csv"
                        onChange={e => {
                            setCsvDesc({
                                ...csvDesc,
                                p_csv: e.currentTarget.files[0],
                                p_errors: []
                            })
                        }}
                    />
                    <div className="col-12">
                        <Button type="submit" size="sm" disabled={csvDesc.p_process}>
                            {!csvDesc.p_process ? <>
                                <i className="fa fa-search"></i>
                                <span className="ml-2">Procesar</span>
                            </> : <>
                                <i className="fa fa-circle-notch fa-spin"></i>
                            </>}
                        </Button>
                    </div>
                    {csvDesc?.p_errors?.length > 0 && <div className="col-12 mt-3">
                        <div className="alert alert-danger">
                            {React.Children.toArray(csvDesc.p_errors.map(e => {
                                return <div>{e.message}</div>
                            }))}
                        </div>
                    </div>}
                </FormCustom>
            </Modal.Body>
        </Modal>

        <Loading show={csvMasivo.p_generate_invoices}>
            <Loading.Img src={Helpers.config.resourcesUrl({ url: '/images/dashboard/preloading.svg' })} alt="Preloading" />
        </Loading>
    </>
}

export default PointPeriod